import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/api";

export default function PasswortReset() {
  const navigate = useNavigate();
  const [token, setToken]       = useState("");
  const [passwort, setPasswort] = useState("");
  const [passwort2, setPasswort2] = useState("");
  const [showPw, setShowPw]     = useState(false);
  const [error, setError]       = useState(null);
  const [success, setSuccess]   = useState(false);
  const [loading, setLoading]   = useState(false);

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get("token");
    if (t) setToken(t);
    else setError("Ungültiger Link.");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(null);
    if (passwort !== passwort2) { setError("Passwörter stimmen nicht überein."); return; }
    setLoading(true);
    try {
      await api.auth.resetPassword({ token, neuesPasswort: passwort });
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Fehler beim Zurücksetzen.");
    } finally { setLoading(false); }
  };

  if (success) return (
    <div className="container" style={{ maxWidth: 420, marginTop: "3rem" }}>
      <div className="alert alert-success" style={{ marginBottom: "1rem" }}>
        Passwort erfolgreich geändert! Du kannst dich jetzt anmelden.
      </div>
      <button className="btn btn-success" style={{ width: "100%" }} onClick={() => navigate("/")}>
        Zur Startseite
      </button>
    </div>
  );

  return (
    <div className="container" style={{ maxWidth: 420, marginTop: "3rem" }}>
      <h2 className="section-title">🔒 Neues Passwort</h2>
      {error && <div className="alert alert-error" style={{ margin: "1rem 0" }}>{error}</div>}
      {token && !error && (
        <form onSubmit={handleSubmit} style={{ marginTop: "1.5rem" }}>
          <div className="form-group">
            <label>Neues Passwort</label>
            <div style={{ position: "relative" }}>
              <input
                type={showPw ? "text" : "password"}
                value={passwort} required minLength={6}
                onChange={e => setPasswort(e.target.value)}
                style={{ paddingRight: "2.5rem" }}
              />
              <button type="button" onClick={() => setShowPw(s => !s)} style={{
                position: "absolute", right: "0.6rem", top: "50%", transform: "translateY(-50%)",
                background: "none", border: "none", cursor: "pointer", fontSize: "1.1rem", color: "#777", padding: 0,
              }}>
                {showPw ? "🙈" : "👁️"}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label>Passwort wiederholen</label>
            <input
              type={showPw ? "text" : "password"}
              value={passwort2} required
              onChange={e => setPasswort2(e.target.value)}
            />
          </div>
          <button className="btn btn-success" type="submit" disabled={loading}
            style={{ width: "100%", marginTop: "0.5rem" }}>
            {loading ? "..." : "Passwort ändern"}
          </button>
        </form>
      )}
    </div>
  );
}
